<template>
  <div>
    <OperationRuleContent />
  </div>
</template>
<script>
import OperationRuleContent from '@/views/helpCenter/components/operationRuleContent'
export default {
  name: 'OperationRule',
  components: {
    OperationRuleContent
  }
}
</script>
<style scoped>
.operation-rule-doc p {
  margin: 8px 0;
  line-height: 30px;
}

.titledoc {
  color: cornflowerblue;
  font-weight: 600;
}
</style>
